import React from 'react';

const variants = {
  primary: 'btn-primary',
  ghost: 'btn-ghost',
  soft: 'btn-soft',
};

const sizes = {
  sm: 'text-xs px-3.5 py-2',
  md: 'text-sm px-5 py-2.5',
  lg: 'text-base px-7 py-3.5',
};

export const Button = React.forwardRef(function Button(
  {
    as: Tag = 'button',
    variant = 'primary',
    size = 'md',
    href,
    icon,
    iconPosition = 'right',
    className = '',
    children,
    ...rest
  },
  ref
) {
  const Component = href ? 'a' : Tag;
  const componentProps = href ? { href, ...rest } : rest;

  return (
    <Component
      ref={ref}
      className={`${variants[variant]} ${sizes[size]} group ${className}`}
      {...componentProps}
    >
      {icon && iconPosition === 'left' && <span className="transition-transform group-hover:-translate-x-0.5">{icon}</span>}
      <span>{children}</span>
      {icon && iconPosition === 'right' && (
        <span className="transition-transform group-hover:translate-x-1">{icon}</span>
      )}
    </Component>
  );
});

export default Button;
